export const getPadding = (top = 0, right = 0, bottom = 0, left = 0) => {
    const padding = {};
    if (top) { padding["padding-top"] = `${top}px`; }
    if (right) { padding["padding-right"] = `${right}px`; }
    if (bottom) { padding["padding-bottom"] = `${bottom}px`; }
    if (left) { padding["padding-left"] = `${left}px`; }

    return padding;
};

export const getMargin = (top = 0, right = 0, bottom = 0, left = 0) => {
    const margin = {};
    if (top) { margin["margin-top"] = `${top}px`; }
    if (right) { margin["margin-right"] = `${right}px`; }
    if (bottom) { margin["margin-bottom"] = `${bottom}px`; }
    if (left) { margin["margin-left"] = `${left}px`; }

    return margin;
};

export const getPaddingAndMargin = (paddingList, marginList) => ({ ...getPadding(...paddingList), ...getMargin(...marginList) });

export const __isFunction = (object) => !!(object && object.constructor && object.call && object.apply);

export const consoleWarn = (...args) => {
    if (process.env.NODE_ENV !== "development") {
        console.warn(...args); // eslint-disable-line
    }
};
